import $ from 'jquery';
import form from '../libs/form';

export default {
    init() {
    },
    finalize() {
        console.log('registrazione');
        form();

        var myParam = location.search.split('c=')[1];
        console.log(myParam);

        $('#codice').attr("readonly", true).val(myParam);
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateRegistrazione.js